import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { mediaUrl } from "../../lib/api";
import { Reveal, Kicker } from "./Reveal";

export const About = ({ content }) => {
  const { t, lang, pick } = useLang();
  const about = content?.about || {};
  const stats = content?.stats || [];
  const chapters = t("chapters");
  const title = about[`title_${lang}`] || "";

  return (
    <section id="about" className="relative bg-taxi py-24 md:py-36 border-y border-black/10" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <Reveal><Kicker>{t("about_kicker")}</Kicker></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-black text-4xl md:text-6xl uppercase whitespace-pre-line leading-[0.95]">
                {title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-black/70 text-base md:text-lg leading-relaxed max-w-2xl">{pick(about, "text")}</p>
            </Reveal>

            <div className="mt-14 space-y-0">
              {chapters.map((c, i) => (
                <Reveal key={i} delay={i * 0.08}>
                  <div className="group flex gap-6 py-6 border-t border-black/15 hover:bg-black/5 transition-colors px-2">
                    <span className="font-display text-usared text-2xl md:text-3xl w-14 shrink-0">{c.n}</span>
                    <div>
                      <h3 className="font-display text-black text-2xl md:text-3xl uppercase leading-none mb-2">{c.t}</h3>
                      <p className="text-black/70 text-sm md:text-base leading-relaxed max-w-lg">{c.d}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="relative border border-black/15 overflow-hidden">
                <img src={mediaUrl(about.image)} alt="MY TAXI" className="w-full h-auto object-cover" />
                <div className="absolute inset-0 ring-1 ring-inset ring-black/10 pointer-events-none" />
              </div>
            </Reveal>
            <div className="grid grid-cols-2 gap-px mt-px bg-black/15 border border-black/15">
              {stats.map((s, i) => (
                <Reveal key={i} delay={i * 0.06}>
                  <div className="bg-surface p-7 hover:bg-ink transition-colors" data-testid={`stat-${i}`}>
                    <div className="font-display text-taxi text-4xl md:text-5xl">{s.value}</div>
                    <div className="text-white/50 text-xs uppercase tracking-widest mt-2">{pick(s, "label")}</div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
